import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import './Page.css';

function Page(props) {
    return (
        <Container fluid={props.fullWidth}>
            <Row>
                <Col xl={props.fullWidth ? 12 : 10} className="mx-auto">
                    <div className={"page-inner rounded" + (props.centered ? " text-center" : "")}>
                        {props.children}
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Page;
